import { setHeader, TEST_API } from "../index";
import axios from "axios";

export default {
  getAllCompanies: (numberOfPage = 1) => {
    let config = {
      method: "GET",
      baseURL: `${TEST_API}/admin/companies?page=${numberOfPage}&perPage=1000`,
      headers: setHeader(),
    };
    return axios(config).then((res) => res && res.data);
  },
  createCompany: (data) => {
    let config = {
      method: "POST",
      baseURL: `${TEST_API}/admin/companies`,
      headers: setHeader(),
      data,
    };
    return axios(config).then((res) => res && res.data);
  },
  importInsuranceCompaniesFromXlsx: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    let config = {
      method: "POST",
      baseURL: `${TEST_API}/admin/companies/import-insurance-companies`,
      headers: {
        ...setHeader(),
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    };
    return axios(config).then((res) => res && res.data);
  },
};
